var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-popover', {
    attrs: {
      "offset": "0",
      "open": _vm.isOpen,
      "trigger": "click",
      "autoHide": true
    },
    on: {
      "auto-hide": _vm.close
    }
  }, [_c('span', {
    staticClass: "tooltip-target",
    attrs: {
      "data-testid": "client-banner-gdpr"
    },
    on: {
      "click": _vm.open
    }
  }, [(_vm.client.gdpr_consent) ? [(_vm.client.gdpr_consent.agreed) ? _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        content: 'souhlasil dne: <b>' + _vm.client.gdpr_consent.recorded_on + '</b>',
        placement: 'bottom-center',
        classes: ['info']
      }),
      expression: "{\n                    content: 'souhlasil dne: <b>' + client.gdpr_consent.recorded_on + '</b>',\n                    placement: 'bottom-center',\n                    classes: ['info']}"
    }],
    staticClass: "badge badge-success",
    attrs: {
      "data-testid": "client-gdpr-badge-agreed"
    }
  }, [_vm._v("\n            GDPR\n          "), _c('i', {
    staticClass: "fa fa-check text-white",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        content: 'NEsouhlasil dne: <b>' + _vm.client.gdpr_consent.recorded_on + '</b>',
        placement: 'bottom-center',
        classes: ['secondary']
      }),
      expression: "{\n                    content: 'NEsouhlasil dne: <b>' + client.gdpr_consent.recorded_on + '</b>',\n                    placement: 'bottom-center',\n                    classes: ['secondary']}"
    }],
    staticClass: "badge badge-secondary",
    attrs: {
      "data-testid": "client-gdpr-badge-disagreed"
    }
  }, [_vm._v("\n            GDPR\n          "), _c('i', {
    staticClass: "fa fa-times text-white",
    attrs: {
      "aria-hidden": "true"
    }
  })])] : _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        content: 'nemá vyplněné GDPR',
        placement: 'bottom-center',
        classes: ['danger']
      }),
      expression: "{\n                    content: 'nemá vyplněné GDPR',\n                    placement: 'bottom-center',\n                    classes: ['danger']}"
    }],
    staticClass: "badge badge-danger",
    attrs: {
      "data-testid": "client-gdpr-badge-missing"
    }
  }, [_vm._v("\n            bez GDPR\n          "), _c('i', {
    staticClass: "fa fa-exclamation-triangle text-white",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('div', {
    staticClass: "container tooltip_container tooltip_1_5_col"
  }, [_c('div', {
    staticClass: "row tooltip_header"
  }, [_c('div', {
    staticClass: "col-sm-2 text-left"
  }, [_c('div', {
    staticClass: "col-sm-2 text-right"
  }, [_c('a', {
    staticClass: "btn btn-sm btn-outline-secondary",
    attrs: {
      "target": "_blank",
      "href": _vm.setting.hostname + 'client/' + _vm.client.id + '/gdpr/pdf'
    }
  }, [_vm._v("Formulář")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("GDPR souhlas klienta")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), (_vm.client.gdpr_consent) ? _c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-7"
  }, [_vm._v("souhlasí s GDPR")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("datum (ne)souhlasu")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  })])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "row m-0 text-left",
    attrs: {
      "data-testid": "client-gdpr-row"
    }
  }, [_c('td', {
    staticClass: "col-sm-7"
  }, [_vm._v(_vm._s(_vm._f("boolToCS")(_vm.client.gdpr_consent.agreed)))]), _vm._v(" "), _c('td', {
    staticClass: "col-sm-3"
  }, [_vm._v(_vm._s(_vm.client.gdpr_consent.recorded_on))]), _vm._v(" "), _c('td', {
    staticClass: "text-right col-sm-2"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "data-testid": "client-gdpr-delete"
    },
    on: {
      "click": function($event) {
        _vm.deleteGdprConsent(_vm.client.gdpr_consent.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])]) : _vm._e(), _vm._v(" "), (!_vm.client.gdpr_consent) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitFormAddGdprConsent($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {}, [_c('span', [_vm._v("Datum (ne)souhlasu:")]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "placeholder": "vybrat datum (ne)souhlasu",
      "format": "dd.MM.yyyy",
      "language": "cs",
      "monday-first": true,
      "full-month-name": true,
      "name": "chooseDate",
      "input-class": "datapickerInput"
    },
    on: {
      "input": function($event) {
        _vm.manualSelectDate($event)
      }
    },
    model: {
      value: (_vm.selectedDate),
      callback: function($$v) {
        _vm.selectedDate = $$v
      },
      expression: "selectedDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                      Souhlasil: \n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGdprConsent.agreed),
      expression: "newGdprConsent.agreed"
    }],
    attrs: {
      "type": "checkbox",
      "data-testid": "client-gdpr-agreed"
    },
    domProps: {
      "checked": Array.isArray(_vm.newGdprConsent.agreed) ? _vm._i(_vm.newGdprConsent.agreed, null) > -1 : (_vm.newGdprConsent.agreed)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.newGdprConsent.agreed,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newGdprConsent.agreed = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.newGdprConsent.agreed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.newGdprConsent.agreed = $$c
        }
      }
    }
  })]), _vm._v(" "), (_vm.newGdprConsentPending === false) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "data-testid": "client-gdpr-submit"
    }
  }, [_vm._v("Přidat")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])]), _vm._v(" "), (_vm.newGdprConsentError.number) ? _c('small', {
    staticClass: "form-text text-danger text-left",
    attrs: {
      "id": "numberError"
    }
  }, [_vm._v(_vm._s(_vm.newGdprConsentError.number.message))]) : _vm._e()])])]) : _vm._e()])])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52e91564","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Client/components/ClientGdprConsent.vue
// module id = 333
// module chunks = 0